//
import { RouteProp } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import React, { useState, useEffect } from 'react';
import { Dimensions, StyleSheet, View, Image } from 'react-native';
import { StackParamList } from '../../../App';
import { TXT_G, TXT_GG, TXT_M } from '../../constants';
import { usePedido } from '../../redux/pedido/pedidoHooks';
import Header from '../Generic/Header';
import PageContainer from '../Generic/PageContainer';
import promocaoApi from '../../apis/promocaoApi';
import Categoria from '../../shared/entity/Categoria';
import ItemCategoria from '../ProdutosPage/ItemCategoria';
import Promocao from '../../shared/entity/Promocao';
import Title from '../Generic/Title';
import cardapioApi from '../../apis/cardapioApi';
import Cardapio from '../../shared/entity/Cardapio';
import { useEmpresa } from '../../redux/empresa/empresaHooks';
import midiaApi from '../../apis/midiaApi';

type Props = {
  navigation: StackNavigationProp<StackParamList, 'PromocaoPage'>;
  route: RouteProp<StackParamList, 'PromocaoPage'>;
};

const PromocaoPage: React.FC<Props> = (props) => {
  const { navigation, route } = props;
  const promocaoId = route.params.promocaoId;

  const [cardapio, setCardapio] = useState<Cardapio | null>(null);
  const [promocao, setPromocao] = useState(new Promocao());
  const [empresa] = useEmpresa();

  const getPromocao = async () => {
    try {
      const resPromo = await promocaoApi.getOne({ where: { id: promocaoId } });
      setPromocao(resPromo);
      const resCardapio = await cardapioApi.getCardapioCompleto({
        promocaoId: resPromo.id,
        empresaId: empresa.id
      });
      setCardapio(resCardapio);
    } catch (err) {
      console.log('ERRO', err);
    }
  };

  const goToProduto = (id: number) => {
    navigation.navigate('AdicionarProdutoPage', { id: id });
  };

  useEffect(() => {
    getPromocao();
  }, []);

  return (
    <PageContainer header={<Header titulo={promocao.nome} goBack />}>
      <Image source={{ uri: midiaApi.getMidia(promocao.urlBanner) }} style={styles.image} />

      <Title style={{ color: '#000', marginBottom: 10 }}>Produtos da Promo:</Title>

      <View style={styles.content}>
        {cardapio &&
          cardapio.categorias.map((categoria) => (
            <ItemCategoria key={categoria.id} categoria={categoria} goToProduto={goToProduto} />
          ))}
      </View>
    </PageContainer>
  );
};

const DEVICE_WIDTH = Dimensions.get('window').width;
const styles = StyleSheet.create({
  content: {
    backgroundColor: '#fff',
    justifyContent: 'center'
  },
  image: { width: '100%', height: 150, resizeMode: 'cover', borderRadius: 7, marginBottom: 15 }
});

export default PromocaoPage;
